import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axiosService from 'utils/axios';
import LoadingSpinner from 'components/Shared/LoadingSpinner/LoadingSpinner';
import SearchBar from 'components/SearchBar/SearchBar';
import CardsView from 'components/Shared/CardsView/CardsView';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import UserCard from './UserCard';
import { userCardStyles } from './styles';
import AddOrEditUser from './AddOrEditUser';

export default function UsersList() {
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [addNewUserModalOpen, setAddNewUserModalOpen] = useState(false);

  const getUsers = useCallback(() => {
    setIsLoading(true);
    axiosService
      .get(`/user/?search=${searchText}`)
      .then(res => {
        setUsers(res.data);
      })
      .finally(() => setIsLoading(false));
  }, [searchText]);

  const onNewUserModalClose = () => {
    getUsers();
    setAddNewUserModalOpen(false);
  };

  useEffect(() => {
    // Fetch users on mount
    getUsers();
  }, [getUsers]);

  return (
    <>
      <SearchBar label="Search a user..." setQuery={setSearchText} />
      <div style={userCardStyles.actionsContainer}>
        <ActionButton type="add" onClick={() => setAddNewUserModalOpen(true)}>
          User
        </ActionButton>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <CardsView
            data={users}
            emptyMessage="No users found."
            // @ts-ignore
            CardComponent={UserCard}
            onUserDelete={getUsers}
            onUserUpdate={getUsers}
          />
          <AddOrEditUser
            onSave={onNewUserModalClose}
            modalTitle="Add new user"
            isModalOpen={addNewUserModalOpen}
            setModalOpen={setAddNewUserModalOpen}
          />
        </>
      )}
    </>
  );
}
